export default __webpack_public_path__ + "static/media/2.8f8a5223.svg";